import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import st from "./DynamicForm.module.scss";

import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import { GetMeditationPlaylistApi,handleDeleteMeditationPlaylist, updateShowOnHome } from "../../services/MeditationPlaylist";

 
function MeditationPlaylist() {
  const navigate = useNavigate();
  const [ismodel, setIsModel] = useState(false);
  const [changeStatusTo, setChangeStatusTo] = useState({});
  const [getUserData, setgetUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 8,
  });
  const [rowCount, setRowCount] = useState(0);

  const { reset } = useForm();


  const getFilter = (data) => {
  
    setgetUserData(data)
  }

 


  const handleShowOnHomeChange = (id, checked) => {
    updateShowOnHome(id, checked, getMeditationSeriesList);
  };

  const columns = () => {
    return [
      {
        field: "sno",
        headerName: "S.No.",
        sortable: true,
        width: 100,
      },
      {
        field: "thumbnail",
        headerName: "Thumbnail",
        sortable: false,
        width: 120,
        renderCell: (params) => (
          <img
            src={params.value} // image URL
            alt="thumbnail"
            style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 5 }}
          />
        ),
      },

      {
        field: "audioUrl",
        headerName: "Voice",
        sortable: false,
        width: 200,
        renderCell: (params) => (
          params.value ? (
            <audio controls style={{ width: '100%' }}>
              <source src={params.value} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          ) : (
            "No audio"
          )
        ),
      },
      
      {
        field: "title",
        headerName: "Title",
        sortable: true,
        width: 200,
      },
      {
        field: "description",
        headerName: "Description",
        sortable: true,
        width: 200,
      },
      {
        field: "duration",
        headerName: "Duration",
        sortable: true,
        width: 200,
      },
      {
        field: "languages",
        headerName: "Language",
        sortable: true,
        width: 200,
      },
      {
        field: "showOnHome",
        headerName: "Show on Home",
        width: 150,
        renderCell: (params) => (
          <Form.Check 
            type="switch"
            id={`custom-switch-${params.row._id}`}
            checked={params.value === true}
            onChange={(e) => handleShowOnHomeChange(params.row._id, e.target.checked)}
          />
        ),
      },
      
      {
        field: "action",
        headerName: "ACTION",
        sortable: false,
        width: 100,
        renderCell: (params) => (
          console.log("params", params),
          <div className="btn-group">
            {/* 
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                getFilter(params.row)
              }}
            >
              <i className="icofont-eye-alt"></i>
            </button>
            */}
            {/* 👉 Edit Button */}
            <button
              type="button"
              className="btn btn-outline-primary ms-2 mt-2"
              onClick={() => navigate(`/edit-meditation-playlist/${params.row._id}`)}
            >
              <i className="icofont-ui-edit"></i>
            </button>
            
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => handleDeleteMeditationPlaylist(params.row._id,getMeditationSeriesList)}
            >
              <i className="icofont-ui-delete"></i>
            </button>
            
          </div>
        ),
      },
    ]
  };

  async function getMeditationSeriesList() {
    setIsLoading(true);
    try {
      // API expects 1-based page, DataGrid uses 0-based
      const response = await GetMeditationPlaylistApi(paginationModel.page + 1, paginationModel.pageSize);
      const { data, total } = await response; 
      console.log("Meditation List Data:", data);
  
      setUserList(
        data?.map((item, i) => {
          return {
            ...item,
            id: item?._id,
            sno: (paginationModel.page * paginationModel.pageSize) + i + 1
          };
        }) || [] 
      );
      setRowCount(total || 0);
    } catch (error) {
      console.error("Error fetching meditation data:", error);
    } finally {
      setIsLoading(false);
    }
  }  

  const clearData = () => {
    setgetUserData({});
    setChangeStatusTo({});
  }

  useEffect(() => {
    getMeditationSeriesList()
  }, [paginationModel])

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Meditation Playlist"
          modalbutton={() => {
            return (
              <div className="col-auto d-flex w-sm-100">
                <button
                  type="button"
                  className="btn btn-primary btn-set-task w-sm-100"
                  onClick={() => navigate("/create-meditation-playlist")}
                >
                  <i className="icofont-plus-circle me-2 fs-6"></i>Add
                </button>
              </div>
            );
          }}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div
                  id="myProjectTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      {userList && <DataGrid
                        rows={userList}
                        columns={columns()}
                        loading={isLoading}
                        pagination
                        paginationMode="server"
                        rowCount={rowCount}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        pageSizeOptions={[8, 10, 25]}
                        sx={{
                          border: "none",
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                        }}
                      />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={ismodel}
        onHide={() => {
          clearData();
          setIsModel(false);
        }}
        style={{ display: "block" }}
      >
        <Modal.Header className="modal-header" closeButton>
          <h5 className="modal-title  fw-bold" id="expaddLabel">
            {changeStatusTo?.modelHeading}
          </h5>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <form>
              <h4
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Are you sure you want to change the status to{" "}
                {changeStatusTo.status}?
              </h4>
              
            </form>
          </div>
        </Modal.Body>
      </Modal>

   

    </div>
  );
}
export default MeditationPlaylist;
